export const isGeneratedMobileEmail = (email) => {
  if (!email || typeof email !== "string") return false;

  const [prefix] = email.split("@");
  if (!prefix) return false;

  return /^\+?\d{7,15}$/.test(prefix);
};

export const getDisplayEmail = (email) => {
  if (!email) return "-";
  return isGeneratedMobileEmail(email) ? "-" : email;
};

export const isRealEmail = (email) => {
  return Boolean(email) && !isGeneratedMobileEmail(email);
};

export const getGeneratedMobileNumberFromEmail = (email) => {
  if (!isGeneratedMobileEmail(email)) return "";

  const [prefix] = email.split("@");
  return prefix || "";
};

export const getEmailOrMobileNumber = (
  { email, mobileNumber } = {},
  fallback = "-"
) => {
  if (isRealEmail(email)) return email;
  return mobileNumber || getGeneratedMobileNumberFromEmail(email) || fallback;
};
